module.exports = __webpack_public_path__ + "static/media/mattiaPennaLogo.96d54be1.png";